import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Link, Typography, alpha, useTheme } from "@mui/material";

const Footer: React.FC = () => {
  const theme = useTheme();
  return (
    <Box
      component="footer"
      role="contentinfo"
      aria-label="Site footer"
      sx={{
        flexShrink: 0,
        position: "sticky",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1080,
        width: "100%",
        py: 2.25,
        px: 2,
        textAlign: "center",
        borderTop: "1px solid",
        borderColor: "divider",
        backgroundColor: alpha(theme.palette.background.paper, 0.93),
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        backgroundImage: `linear-gradient(
          90deg,
          ${alpha(theme.palette.primary.main, 0.07)} 0%,
          ${alpha(theme.palette.secondary.main, 0.11)} 25%,
          ${alpha(theme.palette.primary.light, 0.09)} 50%,
          ${alpha(theme.palette.secondary.main, 0.1)} 75%,
          ${alpha(theme.palette.primary.main, 0.07)} 100%
        )`,
        backgroundSize: "240% 100%",
        animation: "footerGradientFlow 20s linear infinite",
        boxShadow: "0 -12px 40px rgba(15, 23, 42, 0.04)",
        "@media (prefers-reduced-motion: reduce)": {
          animation: "none",
          backgroundSize: "100% 100%",
        },
      }}
    >
      <Typography
        component="div"
        variant="body2"
        sx={{
          color: "text.secondary",
          fontWeight: 600,
          letterSpacing: 0.02,
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          justifyContent: "center",
          alignItems: "center",
          rowGap: 0.5,
        }}
      >
        <span>Made with care for fellow renters</span>
        <Box
          component="span"
          aria-hidden
          sx={{ color: "text.disabled", display: { xs: "none", sm: "inline" } }}
        >
          ·
        </Box>
        <Link
          href="mailto:info.ratemycribs@gmail.com"
          underline="hover"
          color="primary"
          sx={{ fontWeight: 700 }}
        >
          Contact Us
        </Link>
        <Box component="span" aria-hidden sx={{ color: "text.disabled" }}>
          ·
        </Box>
        <Link
          component={RouterLink}
          to="/terms"
          underline="hover"
          color="primary"
          sx={{ fontWeight: 700 }}
        >
          Terms of Service
        </Link>
        <Box component="span" aria-hidden sx={{ color: "text.disabled" }}>
          ·
        </Box>
        <Link
          component={RouterLink}
          to="/privacy"
          underline="hover"
          color="primary"
          sx={{ fontWeight: 700 }}
        >
          Privacy Notice
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
